import React from 'react';
import { Popup, Button } from 'antd-mobile';
import { t } from '../../../../i18n';
import { TmsTaskContainerType } from '../../../../enums/TmsEnum';

export interface TmsContainerFormPopupProps {
  visible: boolean;
  mode: 'add' | 'edit';
  containerForm: Record<number, string>;
  onFormChange: (form: Record<number, string>) => void;
  onConfirm: () => void;
  onCancel: () => void;
  /** 编辑标题 i18n key 或文本 */
  editTitle: string;
  /** 新增标题 i18n key 或文本 */
  addTitle: string;
  /** 可选：目的中心显示（装车页按目的地分组时使用） */
  destinationCenter?: string;
}

const CONTAINER_ITEMS = [
  { type: TmsTaskContainerType.CARTON, labelKey: 'pda.pages.loadingDetail.cardboardBox' },
  { type: TmsTaskContainerType.BAG, labelKey: 'pda.pages.loadingDetail.snakeSkinBag' },
  { type: TmsTaskContainerType.PALLET, labelKey: 'pda.pages.loadingDetail.pallet' },
  { type: TmsTaskContainerType.GAYLORD, labelKey: 'pda.pages.loadingDetail.gaylord' }
];

/**
 * TMS 容器信息表单 Popup（装车/卸车共用）
 * 支持新增和编辑模式，按容器类型（卡板箱、蛇皮袋、托盘、Gaylord）输入数量
 */
export const TmsContainerFormPopup: React.FC<TmsContainerFormPopupProps> = ({
  visible,
  mode,
  containerForm,
  onFormChange,
  onConfirm,
  onCancel,
  editTitle,
  addTitle,
  destinationCenter
}) => {
  const title = mode === 'edit' ? t(editTitle) || editTitle : t(addTitle) || addTitle;

  const handleInputChange = (type: number, value: string) => {
    if (value === '' || /^\d+$/.test(value)) {
      onFormChange({ ...containerForm, [type]: value });
    }
  };

  return (
    <Popup
      visible={visible}
      onMaskClick={onCancel}
      position="bottom"
      bodyStyle={{ borderTopLeftRadius: 12, borderTopRightRadius: 12, minHeight: '260px' }}
    >
      <div className="p-4 flex flex-col gap-4">
        <div className="text-center font-semibold text-base text-black">{title}</div>
        {destinationCenter != null && (
          <div className="text-sm text-gray-700">
            {t('pda.pages.loadingDetail.destinationCenter')}：{' '}
            <span className="font-semibold text-purple-600">{destinationCenter || '-'}</span>
          </div>
        )}
        <div className="mt-2">
          <div className="flex text-sm font-semibold text-gray-800 mb-2">
            <div className="flex-1">{t('pda.pages.loadingDetail.unit')}</div>
            <div className="w-24 text-right">{t('pda.pages.loadingDetail.containerQuantityLabel')}</div>
          </div>
          {CONTAINER_ITEMS.map(item => (
            <div className="flex items-center mb-2 gap-2" key={item.type}>
              <div className="flex-1 text-sm text-gray-800">{t(item.labelKey)}</div>
              <div className="w-24">
                <input
                  type="text"
                  inputMode="numeric"
                  className="w-full border border-gray-300 rounded px-2 py-1 text-sm text-right"
                  placeholder={t('pda.pages.loadingDetail.inputPlaceholder')}
                  value={containerForm[item.type] || ''}
                  onChange={e => handleInputChange(item.type, e.target.value)}
                />
              </div>
            </div>
          ))}
        </div>
        <div className="mt-4 flex gap-3">
          <Button block color="default" onClick={onCancel}>
            {t('pda.pages.loadingDetail.cancel')}
          </Button>
          <Button block color="primary" onClick={onConfirm}>
            {t('pda.pages.loadingDetail.confirm')}
          </Button>
        </div>
      </div>
    </Popup>
  );
};
